import classNames from 'classnames';
import { FC } from 'react';

import { Image } from 'src/general/components/Image/Image';

import styles from './HighlightedFeatureCarouselTile.module.scss';

type HighlightedFeatureItem = {
  title: string;
  imgUrl: string;
};

type HighlightedFeatureCarouselTileProps = {
  item: HighlightedFeatureItem;
  className?: string;
};

export const HighlightedFeatureCarouselTile: FC<HighlightedFeatureCarouselTileProps> = ({ item, className }) => {
  if (!item) return null;
  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.imgContainer}>
        <Image className={styles.image} src={item.imgUrl} width={332} height={186} alt="" />
        <div className={styles.labelBlock}>
          <p className={classNames(styles.title, 'c-fw-bold', 'c-fs-caption')}>{item.title}</p>
        </div>
      </div>
    </div>
  );
};
